import { Composer, useI18n } from 'vue-i18n';

export default class ValidationRules {
  public static MIN_PASSWORD_LENGTH = 12;

  public static getRules() {
    const i18n = useI18n();
    return {
      required: (value: string) => !!value || i18n.t('custom_validations.required'),
      max: (value: string, size: number) => value.length <= size || i18n.t('custom_validations.max') + size,
      min: (value: string, size: number = this.MIN_PASSWORD_LENGTH) =>
        value.length >= size || i18n.t('custom_validations.min') + size,
      numeric: (value: string) => /^\d+$/.test(value) || i18n.t('custom_validations.numeric'),
      email: (value: string) =>
        /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(
          value
        ) || i18n.t('custom_validations.email'),
      phone_number: (value: string) =>
        value.length == 0 ||
        /^(\+\d{1,3}|\d{4}( )?)?(\d\s?){9,11}$/.test(value) ||
        i18n.t(`custom_validations.phone_number`),
      password_match: (value1: string, value2: string) =>
        value1 === value2 || i18n.t(`custom_validations.password_match`),
      extended_alphanumeric: (value: string) =>
        /^[-'’\p{L}\p{M}\p{N}\s]+$/giu.test(value) || i18n.t(`custom_validations.extended_alphanumeric`),
      password: (value: string) => this.isValidPassword(i18n, value)
    };
  }

  public static isValidPassword(i18n: Composer, value: string): boolean | string {
    return (
      value.length >= this.MIN_PASSWORD_LENGTH ||
      i18n.t(`custom_validations.passwordrequirements`) + this.MIN_PASSWORD_LENGTH
    );
  }
}
